import { Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AppSettings } from "src/app/app.settings";
import { ApiSevicesService } from "src/app/shared/services/api-sevices.service";
import { ToastrService } from "ngx-toastr";
import { Settings } from "../../app.settings.model";
import { FileDowloadService } from "src/app/shared/services/file-dowload.service";
import { PagerModule } from "src/app/shared/constants/pages.const";
import { ConfirmationComponent } from "src/app/shared/component/confirmation/confirmation.component";
@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.scss"],
})
export class ReportComponent implements OnInit {
  public settings: Settings;
  formData: FormData | null = null;
  page: any = PagerModule;
  constructor(
    public dialog: MatDialog,
    public appSettings: AppSettings,
    public api: ApiSevicesService,
    private toast: ToastrService,
    private fileDownload: FileDowloadService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    setTimeout(() => {
      this.getReportList();
    }, 0);
  }

  @HostListener("dragover", ["$event"]) onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("dragleave", ["$event"]) onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("drop", ["$event"]) onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const fileList = event.dataTransfer?.files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.storeFileInFormData(file);
    }
  }

  onFileChange(event: Event) {
    const fileList = (event.target as HTMLInputElement).files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.storeFileInFormData(file);
    }
  }

  private storeFileInFormData(file: File) {
    this.settings.loadingSpinner = true;
    this.formData = new FormData();
    this.formData.append("file", file);
    this.api.createReport(this.formData).subscribe({
      next: (res: any) => {
        this.toast.success(res.message);
        this.getReportList();
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  public displayedColumns: string[] = [
    "id",
    "fileName",
    "totalRecords",
    "registerRecords",
    "created_at",
    "status",
    "action",
  ];
  public dataSource: any;

  getReportList() {
    this.settings.loadingSpinner = true;
    this.api.getReport(this.page).subscribe({
      next: (res: any) => {
        this.dataSource = res.data;
        this.page = res.pager;
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  refresh() {
    this.getReportList();
  }

  deleteFile(id: number, name: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        filename: name,
        title: "Delete",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.settings.loadingSpinner = true;
        this.api.deleteReport(id).subscribe({
          next: (res: any) => {
            this.toast.success(res.message);
            this.getReportList();
          },
          error: (error) => {
            this.toast.error(error.error.message);
            this.settings.loadingSpinner = false;
          },
        });
      }
    });
  }

  downloadFile(id: number, name: string) {
    this.settings.loadingSpinner = true;
    this.api.downloadReport(id).subscribe({
      next: (res) => {
        this.fileDownload.downloadFIle(res, name);
        this.toast.success("File Download Succefull.");
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  pageChange(e: any) {
    this.page.limit = e.pageSize;
    this.page.page = e.pageIndex + 1;
    this.getReportList();
  }
}
